/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AgencyBarCodeDto } from '../../models/agency-bar-code-dto';
import { NotificationMessage } from '../../models/notification-message';

export interface ApiAgencybarcodePost$Params {
  'api-version'?: string;
      body?: AgencyBarCodeDto
}

export function apiAgencybarcodePost(http: HttpClient, rootUrl: string, params?: ApiAgencybarcodePost$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationMessage>> {
  const rb = new RequestBuilder(rootUrl, apiAgencybarcodePost.PATH, 'post');
  if (params) {
    rb.query('api-version', params['api-version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificationMessage>;
    })
  );
}

apiAgencybarcodePost.PATH = '/api/agencybarcode';
